import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ExpandCircleDownProps = IconComponentBaseProps;

export const ExpandCircleDown = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ExpandCircleDownProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7328_2959"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7328_2959)">
        <path
          d="M12 13.0308L9.44225 10.473C9.30542 10.3347 9.13433 10.2655 8.929 10.2655C8.72383 10.2655 8.54683 10.3347 8.398 10.473C8.243 10.6218 8.16708 10.8001 8.17025 11.0078C8.17342 11.2154 8.24933 11.3936 8.398 11.5423L11.3673 14.5115C11.5481 14.6923 11.759 14.7828 12 14.7828C12.241 14.7828 12.4519 14.6923 12.6328 14.5115L15.6173 11.527C15.7659 11.3782 15.8393 11.2025 15.8375 11C15.8355 10.7975 15.757 10.6218 15.602 10.473C15.4532 10.3347 15.2775 10.2645 15.075 10.2625C14.8725 10.2607 14.6968 10.3341 14.548 10.4827L12 13.0308ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
